import { useMultiSelect } from "./Root"
import * as Combobox from "../Combobox"

type InputOwnProps = Readonly<{
  onInputValueChange?: (value: string) => void
}>

export type InputProps = InputOwnProps &
  Pick<Combobox.ComboboxProps, "items"> &
  React.ComponentPropsWithRef<typeof Combobox.Input>

const Input: React.FC<InputProps> = ({ items, onInputValueChange, ...comboboxProps }: InputProps) => {
  const { dispatch } = useMultiSelect(`Input`)

  return (
    <Combobox.Root items={items}>
      <Combobox.Input onInputValueChange={onInputValueChange} {...comboboxProps} />
      <Combobox.Content
        onValueSelect={(value: string) => {
          dispatch({ type: `addTag`, tag: value })
        }}
      />
    </Combobox.Root>
  )
}

Input.displayName = `MultiSelectInput`

export { Input }
